import stripeCheckoutRedirectHTML from './stripeCheckout'

export default stripeCheckoutRedirectHTML
